<mat-icon [svgIcon]="data.type" [ngClass]="'notification__icon teller-online-icon teller-online-icon--'+data.type"></mat-icon>
<span class="notification__message">{{data.message}}</span>
<div matSnackBarActions class="notification__actions" *ngIf="data.hasDismiss">
    <button matSnackBarAction (click)="snackBarRef.dismiss()" mat-icon-button aria-label="Dismiss Notification">
        <mat-icon>close</mat-icon>
    </button>
</div>